<template>
  <div class="wrapper fadeInDown">
      <!-- <Toast style="margin-top: 35px" /> -->
      <Toast style="margin-top: 10px" />
            <div id="formContentReg">
                <!-- Tabs Titles -->
                <!-- <router-link to="/login"> <h2 class="inactive underlineHover">Log In</h2></router-link> -->

                  <!-- <div id="formLogo">
                   
                </div> -->
                <div style="float: left;margin:4px -406px 0px -306px;">
                 <span class="underlineHover">Supported by:</span>
                    <span> <a href="https://kathmandu.bachpanglobal.in/" target="_blank"><img  style="width: 10%;" src="https://bestdataprovider.com/wp-content/uploads/Bachpan-A-Play-School-Bachpan.png"  alt="Bachpan" /></a> </span>
                </div>

                 <div style="float: left;margin:14px 0px -40px -40px;">
                 <!-- <span class="underlineHover">Supported by:</span> -->
                    <span> <a href="https://rishihood.edu.in/" target="_blank"><img  style="width: 23%;" src="/static/img/rishihood.jpg"  alt="Rishihood" /></a> </span>
                </div>
                <div style="float: right;margin: -4% -9% -24% 71%;">
                 <!-- <span class="underlineHover">Supported by:</span> -->
                    <span> <a href="https://www.facebook.com/Trainer-LNP-109487184253506/" target="_blank"><img  style="width: 38%;" src="/static/img/lnp.jpg"  alt="LNP" /></a> </span>
                </div>
                 <h1 class="active" style="margin-bottom: -1px;margin-left: -52%;">  Sell Like Cheetah
                 </h1>
                  <br style="margin-bottom: -1px;">
                 <h6 class="active">
                   Science behind rapid Sales Closing
                   </h6>
                    <br >
                  <h4 class="active" style="margin: 2px 8px 10px 8px; border-bottom: 0px solid #5fbae9;"> & </h4>
                   <br style="margin-bottom: -1px;">
                   <h1  style="margin-bottom: -1px;" class="active">Get Connected
                   </h1>
                  <br >
                 <h6 class="active" style="margin-bottom: 5px;">
                   Science of reaching more people to sell
                   </h6>
                    <br >
                   <h4 class="active"> ५ जेठ २०७८ बुधवार, May 19, 2021 (Wednesday) 6 PM </h4>
                  <!-- <h2 class="active"> </h2> -->
                  <h1 class="active">Registration charges NPR 300/-
                   </h1>
                 <h3 class="active"> Registration </h3>
                  

                <form>
                    <div class="wrap-input1 validate-input" data-validate = "Name is required">
                        <input class="fadeIn " type="text" v-model="name" placeholder="Name">
                        <span class="shadow-input1"></span>
                    </div>
                    <div class="wrap-input1 validate-input" data-validate = "Valid email is required: ex@abc.xyz">
                        <input class="input1" type="text" v-model="email" placeholder="Email">
                        <span class="shadow-input1"></span>
                    </div>

                    <div class="wrap-input1">
                        <input class="input1" type="text" v-model="address" placeholder="Address">
                        <span class="shadow-input1"></span>
                    </div>

                    <div class="wrap-input1 validate-input" data-validate = "Mobile number is required: 9800xxx">
                        <input class="input1" type="text" v-model="phone" placeholder="Mobile number">
                        <span class="shadow-input1"></span>
                    </div>

                     <div class="wrap-input1">
                        <input class="input1" type="text" v-model="paymentDetails" placeholder="Payment Details">
                        <span class="shadow-input1"></span>
                    </div>


                    <div class="wrap-input1 validate-input" data-validate = "Message is required">
                        <textarea class="input1" v-model="feedback" placeholder="Have you joined Mr. Lekh Nath Poudel's training before? If yes! Feedback please."></textarea>
                        <span class="shadow-input1"></span>
                    </div>

                    <div class="wrap-input1 validate-input" data-validate = "Message is required">
                        <textarea class="input1" v-model="message" placeholder="Why you want to join this session?"></textarea>
                        <span class="shadow-input1"></span>
                    </div>


                         <div class="wrap-input1 validate-input">
                       <span class="underlineHover">For Payment Please Click.</span>
                    <!-- <span> <a href="https://kathmandu.bachpanglobal.in/" target="_blank"></a> </span> -->
                      <span> <a href="/static/img/payment.jpg" target="_blank"><img  style="width: 10%;" src="/static/img/pay.jpg"  alt="Payment" /></a> </span>
                    </div>

                    <div class="container-contact1-form-btn">
                        <button class="contact1-form-btn" @click.prevent="sendInquiry">
                            <span>
                                Register
                                <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                            </span>
                        </button>
                    </div>
                </form>

                <!-- <div id="formFooter">
                    <span class="underlineHover">Powered by</span>
                    <span> <a href="https://raisetech.com.np" target="_blank"><img src="static/img/lnp.jpg.png"  alt="Raiselogo" /></a> </span>
                </div> -->
            </div>

        </div>
</template>
<script>
import Toast from 'primevue/toast'
export default {
  name: 'Inquiry',
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      message: '',
      company: '',
      subject: '',
      feedback: '',
      paymentDetails: '',
      address: ''

    }
  },
  methods: {
    async sendInquiry() {
      if (this.name.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please entry your name!', life: 10000})
        return
      }
      if (this.email.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please entry your email!', life: 10000})
        return
      }
      if (this.phone.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please entry your contact!', life: 10000})
        return
      }
      if (this.message.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please entry message!', life: 10000})
        return
      }
      let inquiryData = {
        name: this.name,
        email: this.email,
        contactNumber: this.phone,
        address: this.address,
        message: this.message,
        feedback: this.feedback,
        paymentDetails: this.paymentDetails
      }
      this.loading = true
      let response = await this.$store.dispatch('registerEvent', inquiryData)
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      }
      this.reset()
    },
    reset() {
      this.name = ''
      this.email = ''
      this.phone = ''
      this.address = ''
      this.message = ''
      this.feedback = ''
      this.paymentDetails = ''
    }
  },
  components: {
    Toast
  }
}
</script>
<style scoped  src="@../../../static/css/loginpage.css">
</style>



// WEBPACK FOOTER //
// registerEvent.vue?7082f34c